'use client';

import { ThemeProvider } from '@/context/ThemeContext';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import '../lib/fontawesome';

// FontAwesome configuration
// - autoAddCss: false to prevent double-adding styles
// - This must be set before any icons are rendered
config.autoAddCss = false;

// This effect ensures consistent rendering between server and client
if (typeof window !== 'undefined') {
  // Client-side only code
  import('@fortawesome/fontawesome-svg-core').then(({ config, dom }) => {
    // This ensures the same configuration is used for all icons
    config.autoAddCss = false;
  });
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      {children}
    </ThemeProvider>
  );
}
